import React, { useContext } from 'react'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { AnalyticsMediaOverviewFilter } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { MediaAnalyticsCsvDocument } from './Media.codegen'
import { AnalyticsContext } from '../AnalyticsContext'
import { prepareCSVMediaExport } from './csv-media'

interface IDownloadMediaCSVProps {
  className?: string
  mediaOverviewFilter: AnalyticsMediaOverviewFilter
  mediaCount: number
  title: string
  disabled?: boolean
}

export const DownloadMediaCSV = ({
  className = '',
  mediaOverviewFilter,
  mediaCount,
  title
}: IDownloadMediaCSVProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  return (
    <DownloadCSVButton
      className={className}
      count={mediaCount}
      fileName={'looop-media'}
      dataPath={'data.analytics.media.mediaOverview'}
      title={title}
      queryOptions={(page, limit) => ({
        variables: {
          mainAnalyticsFilter: filterAsQueryVariables,
          mediaOverviewFilter: {
            ...mediaOverviewFilter,
            page,
            limit
          }
        },
        query: MediaAnalyticsCsvDocument
      })}
      prepareData={prepareCSVMediaExport}
    />
  )
}
